'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { getRelativeURLWithParams } from 'utils/url';

export const useHelpCenterLinkClient = ({
  helpCenterUrl = '',
}: {
  helpCenterUrl: string;
}) => {
  const [pageGroup, setPageGroup] = useState<string>();
  const pathname = usePathname();
  useEffect(() => {
    const pageGroupElement: HTMLMetaElement | null = document.querySelector(
      'meta[name="pageGroup"]'
    );

    setPageGroup(pageGroupElement?.content);
  }, [pathname]);

  return {
    helpCenterUrlWithCurrentPage: getRelativeURLWithParams(helpCenterUrl, {
      pccCurrentPage: pageGroup
    },{sort:false}),
  };
};
